export { default as AppStoreLogo } from "./AppStoreLogo";
export { default as PlayStoreLogo } from "./PlayStoreLogo";
export { default as Spinner } from "./Spinner";
export { default as PhoneIcon } from "./PhoneIcon";
export { default as PostalMailIcon } from "./PostalMailIcon";
export { default as CrossToCloseIcon } from "./CrossToCloseIcon";
